import styled from "styled-components";
import { typographyMixin } from "../../../design-system/tokens/typography";

export const ProfileChartViewport = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  min-width: 0;
  min-height: 0;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  .vega-embed,
  .vega-embed > div {
    display: block;
    max-width: 100%;
    max-height: 100%;
  }

  .vega-embed svg,
  .vega-embed canvas {
    display: block;
    max-width: 100%;
    max-height: 100%;
  }
`;

export const ProfileChartEmptyState = styled.span`
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  ${typographyMixin("caption", 4)}
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const ProfileChartStoryFrame = styled.div`
  width: ${({ theme }) => theme.spacing.base[50]};
  height: ${({ theme }) => theme.spacing.base[32]};
`;
